/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from '../client/http-client';
import {
  type CheckDeletableVoteRequestDto,
  type CreateSpaceRequestDto,
  type CreateVoteRequestDto,
  type CursorPaginationResponseDtoSpaceResponseDto,
  type CursorPaginationResponseDtoVoteResponseDto,
  type ErrorResponseDto,
  type OffsetPaginationResponseDtoUserVoteResponseDto,
  type OffsetPaginationResponseDtoVoteResponseDto,
  type OffsetPaginationResponseDtoVoteStatisticsResponseDto,
  type ParticipateVoteRequestDto,
  type SpaceResponseDto,
  type SuccessCountResponseDto,
  type SuccessIdResponseDto,
  type UpdateSpaceRequestDto,
  type VotableAmountResponseDto,
  type VoteResponseDto,
  type VoteStatisticsResponseDto,
} from '../dto/data-contracts';

export class Dao<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 모든 스페이스 조회
   *
   * @tags DAO
   * @name FindAll1
   * @summary 모든 스페이스 조회
   * @request GET:/v1/spaces
   */
  findAll1 = (
    query?: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      /** @default "RECENT" */
      sortField?: 'RECENT';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoSpaceResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/spaces`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description 스페이스 생성
   *
   * @tags DAO
   * @name CreateSpace
   * @summary 스페이스 생성
   * @request POST:/v1/spaces
   * @secure
   */
  createSpace = (data: CreateSpaceRequestDto, params: RequestParams = {}) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/spaces`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 스페이스 수정
   *
   * @tags DAO
   * @name UpdateSpace
   * @summary 스페이스 수정
   * @request POST:/v1/spaces/{spaceId}
   * @secure
   */
  updateSpace = (
    spaceId: string,
    data: UpdateSpaceRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/spaces/${spaceId}`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 스페이스의 투표 참여 목록 조회
   *
   * @tags DAO
   * @name FindVoteParticipations
   * @summary 스페이스의 투표 참여 목록 조회
   * @request GET:/v1/spaces/{spaceId}/vote-participations
   */
  findVoteParticipations = (
    spaceId: string,
    query?: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /**
       * 요청 페이지 번호
       * @format int32
       * @min 1
       */
      requestPageNumber?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      /** @default "RECENT" */
      sortField?: 'RECENT' | 'MOST_VOTE_COUNT';
      /** @default "ALL" */
      status?: 'ALL' | 'WAITING' | 'IN_PROGRESS' | 'COMPLETED';
      userId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      OffsetPaginationResponseDtoUserVoteResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/spaces/${spaceId}/vote-participations`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description 스페이스의 투표 통계 목록 조회
   *
   * @tags DAO
   * @name FindVoteStatistics
   * @summary 스페이스의 투표 통계 목록 조회
   * @request GET:/v1/spaces/{spaceId}/vote-statistics
   */
  findVoteStatistics = (
    spaceId: string,
    query?: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /**
       * 요청 페이지 번호
       * @format int32
       * @min 1
       */
      requestPageNumber?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      /** @default "RECENT" */
      sortField?:
        | 'RECENT'
        | 'MOST_VOTE_COUNT'
        | 'MOST_PARTICIPANT_COUNT'
        | 'END_DATE';
      /** @default "WAITING" */
      status?: 'ALL' | 'WAITING' | 'IN_PROGRESS' | 'COMPLETED';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      OffsetPaginationResponseDtoVoteStatisticsResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/spaces/${spaceId}/vote-statistics`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description 스페이스의 투표 목록 조회
   *
   * @tags DAO
   * @name FindVotes
   * @summary 스페이스의 투표 목록 조회
   * @request GET:/v1/spaces/{spaceId}/votes
   */
  findVotes = (
    spaceId: string,
    query?: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /**
       * 요청 페이지 번호
       * @format int32
       * @min 1
       */
      requestPageNumber?: number;
      search?: string;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      /** @default "RECENT" */
      sortField?: 'RECENT';
      /** @default "ALL" */
      status?: 'ALL' | 'WAITING' | 'IN_PROGRESS' | 'COMPLETED';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      OffsetPaginationResponseDtoVoteResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/spaces/${spaceId}/votes`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description 가입한 스페이스 조회
   *
   * @tags DAO
   * @name FindJoinedSpaceByUserId
   * @summary 가입한 스페이스 조회
   * @request GET:/v1/users/{userId}/joined-spaces
   * @secure
   */
  findJoinedSpaceByUserId = (
    userId: string,
    query?: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      /** @default "RECENT" */
      sortField?: 'RECENT';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoSpaceResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/joined-spaces`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 유저가 가입한 스페이스의 투표 목록 조회
   *
   * @tags DAO
   * @name FindJoinedSpaceVoteByUserId
   * @summary 유저가 가입한 스페이스의 투표 목록 조회
   * @request GET:/v1/users/{userId}/joined-spaces/votes
   * @secure
   */
  findJoinedSpaceVoteByUserId = (
    userId: string,
    query?: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      /** @default "RECENT" */
      sortField?: 'RECENT';
      /** 마지막 조회 데이터의 정렬 필드 값 */
      sortedFieldValue?: string;
      /** @default "ALL" */
      status?: 'ALL' | 'WAITING' | 'IN_PROGRESS' | 'COMPLETED';
      /** 마지막 조회 데이터의 고유 필드 값 */
      uniqueObjectValue?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      CursorPaginationResponseDtoVoteResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/users/${userId}/joined-spaces/votes`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 유저가 만든 스페이스 조회
   *
   * @tags DAO
   * @name FindCreatedSpaceByUserId
   * @summary 유저가 만든 스페이스 조회
   * @request GET:/v1/users/{userId}/space
   */
  findCreatedSpaceByUserId = (userId: string, params: RequestParams = {}) =>
    this.http.request<SpaceResponseDto, ErrorResponseDto>({
      path: `/v1/users/${userId}/space`,
      method: 'GET',
      ...params,
    });
  /**
   * @description 삭제 가능 여부 확인
   *
   * @tags DAO
   * @name CheckDeletableVote
   * @summary 삭제 가능 여부 확인
   * @request GET:/v1/vote-actions/deletable
   * @secure
   */
  checkDeletableVote = (
    query?: {
      body?: CheckDeletableVoteRequestDto;
      voteId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessCountResponseDto, ErrorResponseDto>({
      path: `/v1/vote-actions/deletable`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 투표에 참여하기
   *
   * @tags DAO
   * @name ParticipateVote
   * @summary 투표에 참여하기
   * @request POST:/v1/vote-actions/participate
   * @secure
   */
  participateVote = (
    data: ParticipateVoteRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/vote-actions/participate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 투표권 수 확인
   *
   * @tags DAO
   * @name GetVotableAmount
   * @summary 투표권 수 확인
   * @request GET:/v1/vote-actions/votable-amount
   * @secure
   */
  getVotableAmount = (
    query: {
      userId: string;
      voteId: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<VotableAmountResponseDto, ErrorResponseDto>({
      path: `/v1/vote-actions/votable-amount`,
      method: 'GET',
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description 모든 투표 목록 조회
   *
   * @tags DAO
   * @name FindAll
   * @summary 모든 투표 목록 조회
   * @request GET:/v1/votes
   */
  findAll = (
    query: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /**
       * 요청 페이지 번호
       * @format int32
       * @min 1
       */
      requestPageNumber?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      sortField: 'RECENT';
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      OffsetPaginationResponseDtoVoteResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/votes`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description 투표 생성
   *
   * @tags DAO
   * @name CreateVote
   * @summary 투표 생성
   * @request POST:/v1/votes
   * @secure
   */
  createVote = (data: CreateVoteRequestDto, params: RequestParams = {}) =>
    this.http.request<SuccessIdResponseDto, ErrorResponseDto>({
      path: `/v1/votes`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 투표 삭제
   *
   * @tags DAO
   * @name DeleteVote
   * @summary 투표 삭제
   * @request DELETE:/v1/votes/{voteId}
   * @secure
   */
  deleteVote = (voteId: string, params: RequestParams = {}) =>
    this.http.request<SuccessCountResponseDto, ErrorResponseDto>({
      path: `/v1/votes/${voteId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * @description 투표 상세 조회
   *
   * @tags DAO
   * @name FindVoteById
   * @summary 투표 상세 조회
   * @request GET:/v1/votes/{voteId}
   */
  findVoteById = (voteId: string, params: RequestParams = {}) =>
    this.http.request<VoteResponseDto, ErrorResponseDto>({
      path: `/v1/votes/${voteId}`,
      method: 'GET',
      ...params,
    });
  /**
   * @description 투표 참여 목록 조회
   *
   * @tags DAO
   * @name FindProgressById
   * @summary 투표 참여 목록 조회
   * @request GET:/v1/votes/{voteId}/participations
   */
  findProgressById = (
    voteId: string,
    query?: {
      /**
       * 조회할 데이터 수
       * @format int32
       * @max 50
       */
      limit?: number;
      /**
       * 요청 페이지 번호
       * @format int32
       * @min 1
       */
      requestPageNumber?: number;
      /** 정렬 방향 */
      sortDirection?: 'ASC' | 'DESC';
      /** @default "RECENT" */
      sortField?: 'RECENT' | 'MOST_VOTE_COUNT';
      userId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<
      OffsetPaginationResponseDtoUserVoteResponseDto,
      ErrorResponseDto
    >({
      path: `/v1/votes/${voteId}/participations`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * @description 투표 통계 조회
   *
   * @tags DAO
   * @name FindStatisticsById
   * @summary 투표 통계 조회
   * @request GET:/v1/votes/{voteId}/statistics
   */
  findStatisticsById = (voteId: string, params: RequestParams = {}) =>
    this.http.request<VoteStatisticsResponseDto, ErrorResponseDto>({
      path: `/v1/votes/${voteId}/statistics`,
      method: 'GET',
      ...params,
    });
}
